// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3Zjr9","selects":"Documents_selects__2-I26"};